module.exports = __webpack_public_path__ + "static/blog-7fdf2270f1506f6d4389bb26c850ceae.png";